// import React from "react";
// import Highcharts from "highcharts";
// import HighchartsReact from "highcharts-react-official";
// import HighchartsDrilldown from "highcharts/modules/drilldown";

// // Initialize drilldown module
// if (typeof Highcharts === "object") {
//   HighchartsDrilldown(Highcharts);
// }

// const manualData = {
//   "Category III Codes": {
//     "Prostate Ablation Procedure": {
//       "Anthem Participating Network": 272.95,
//       "BC ID Blue Value POS Network": 333.09,
//       "BC ID Preferred Blue Network": 333.09,
//       "BC ID Preferred Blue PPO Network": 294.65,
//     },
//     "Atherectomy (Open or Percutaneous) for Supra-Inguinal Arteries": {
//       "Anthem Participating Network": 147.22,
//       "BC ID Blue Value POS Network": 147.22,
//       "BC ID Preferred Blue Network": 147.22,
//       "BC ID Preferred Blue PPO Network": 147.22,
//     },
//     "Laser Ablation Procedures": {
//       "Anthem Participating Network": 605.01,
//       "BC ID Blue Value POS Network": 605.01,
//       "BC ID Preferred Blue Network": 605.01,
//       "BC ID Preferred Blue PPO Network": 605.01,
//     },
//     "Stereotactic Intracranial Lesion Ablation Procedure": {
//       "Anthem Participating Network": 338.44,
//       "BC ID Blue Value POS Network": 298.36,
//       "BC ID Preferred Blue Network": 298.36,
//       "BC ID Preferred Blue PPO Network": 338.44,
//     },
//     "Transnasal EGD and Capsule Endoscopy Procedures": {
//       "Anthem Participating Network": 584.68,
//       "BC ID Blue Value POS Network": 584.68,
//       "BC ID Preferred Blue Network": 584.68,
//       "BC ID Preferred Blue PPO Network": 584.68,
//     },
//     "Carotid Sinus Baroreflex Activation Device Procedures": {
//       "Anthem Participating Network": 278.66,
//       "BC ID Blue Value POS Network": "Unavailable",
//       "BC ID Preferred Blue Network": "Unavailable",
//       "BC ID Preferred Blue PPO Network": 278.66,
//     },
//     "Imaging, Testing, Implantation and Other Services": {
//       "Anthem Participating Network": 619.55,
//       "BC ID Blue Value POS Network": 619.55,
//       "BC ID Preferred Blue Network": 619.55,
//       "BC ID Preferred Blue PPO Network": 619.55,
//     },
//     "Insertion of Aqueous Drainage Device": {
//       "Anthem Participating Network": 207.97,
//       "BC ID Blue Value POS Network": "Unavailable",
//       "BC ID Preferred Blue Network": "Unavailable",
//       "BC ID Preferred Blue PPO Network": 207.97,
//     },
//     "Intracardiac Ischemia Monitoring Procedures": {
//       "Anthem Participating Network": 153.86,
//       "BC ID Blue Value POS Network": 153.86,
//       "BC ID Preferred Blue Network": 153.86,
//       "BC ID Preferred Blue PPO Network": 153.86,
//     },
//     "Percutaneous Lumbar Intravertebral Disc Injection Procedure": {
//       "Anthem Participating Network": 178.15,
//       "BC ID Blue Value POS Network": 178.15,
//       "BC ID Preferred Blue Network": 178.15,
//       "BC ID Preferred Blue PPO Network": 178.15,
//     },
//   },
//   "Chemotherapy Drugs": {
//     "Chemotherapy Drugs": {
//       "Anthem Participating Network": 250.98,
//       "BC ID Blue Value POS Network": 243.03,
//       "BC ID Preferred Blue Network": 243.03,
//       "BC ID Preferred Blue PPO Network": 242.29,
//     },
//   },
//   "Drugs Administered Other than Oral Method": {
//     "Drugs, Administered by Injection": {
//       "Anthem Participating Network": 260.7,
//       "BC ID Blue Value POS Network": 247.36,
//       "BC ID Preferred Blue Network": 247.36,
//       "BC ID Preferred Blue PPO Network": 252.38,
//     },
//     "Miscellaneous Drugs": {
//       "Anthem Participating Network": 234.78,
//       "BC ID Blue Value POS Network": 239.27,
//       "BC ID Preferred Blue Network": 239.27,
//       "BC ID Preferred Blue PPO Network": 235.47,
//     },
//     "Clotting Factors": {
//       "Anthem Participating Network": 227.49,
//       "BC ID Blue Value POS Network": 215.47,
//       "BC ID Preferred Blue Network": 215.47,
//       "BC ID Preferred Blue PPO Network": 214.66,
//     },
//     "Chemotherapy Drugs, Oral Administration": {
//       "Anthem Participating Network": 241.13,
//       "BC ID Blue Value POS Network": "Unavailable",
//       "BC ID Preferred Blue Network": "Unavailable",
//       "BC ID Preferred Blue PPO Network": 241.13,
//     },
//     "Immunosuppressive Drugs": {
//       "Anthem Participating Network": 188.53,
//       "BC ID Blue Value POS Network": 188.53,
//       "BC ID Preferred Blue Network": 188.53,
//       "BC ID Preferred Blue PPO Network": 188.53,
//     },
//   },
//   "Evaluation and Management": {
//     "Preventive Medicine Services": {
//       "Anthem Participating Network": 298.53,
//       "BC ID Blue Value POS Network": 288.5,
//       "BC ID Preferred Blue Network": 288.5,
//       "BC ID Preferred Blue PPO Network": 312.29,
//     },
//     "Transitional Care Management Services": {
//       "Anthem Participating Network": 309.17,
//       "BC ID Blue Value POS Network": 314.26,
//       "BC ID Preferred Blue Network": 314.26,
//       "BC ID Preferred Blue PPO Network": 322.86,
//     },
//     "Psychiatric Collaborative Care Management Services": {
//       "Anthem Participating Network": 293.26,
//       "BC ID Blue Value POS Network": 213.38,
//       "BC ID Preferred Blue Network": 213.38,
//       "BC ID Preferred Blue PPO Network": 293.26,
//     },
//     "Care Management Services": {
//       "Anthem Participating Network": 204.65,
//       "BC ID Blue Value POS Network": 204.65,
//       "BC ID Preferred Blue Network": 204.65,
//       "BC ID Preferred Blue PPO Network": 204.65,
//     },
//     "Newborn Care Services": {
//       "Anthem Participating Network": 389.88,
//       "BC ID Blue Value POS Network": 389.88,
//       "BC ID Preferred Blue Network": 389.88,
//       "BC ID Preferred Blue PPO Network": 389.88,
//     },
//     "Delivery/Birthing Room Attendance and Resuscitation Services": {
//       "Anthem Participating Network": 209.07,
//       "BC ID Blue Value POS Network": 209.07,
//       "BC ID Preferred Blue Network": 209.07,
//       "BC ID Preferred Blue PPO Network": 209.07,
//     },
//   },
//   "Medicine Services and Procedures": {
//     "Cardiovascular Procedures": {
//       "Anthem Participating Network": 360.68,
//       "BC ID Blue Value POS Network": 339.42,
//       "BC ID Preferred Blue Network": 339.42,
//       "BC ID Preferred Blue PPO Network": 359.71,
//     },
//   },
// };

// const processData = (data) => {
//   const seriesData = [];
//   const drilldownSeries = [];

//   Object.entries(data).forEach(([category, subcategories]) => {
//     const categoryData = [];

//     Object.entries(subcategories).forEach(
//       ([subcategory, networks], subIndex) => {
//         const subcategoryId = `${category}-${subcategory}`;
//         categoryData.push({
//           name: subcategory,
//           y: Object.values(networks)[0],
//           drilldown: subcategoryId,
//         });

//         const networkData = Object.entries(networks).map(([network, value]) => [
//           network,
//           value,
//         ]);
//         drilldownSeries.push({ id: subcategoryId, data: networkData });
//       }
//     );

//     seriesData.push({ name: category, data: categoryData });
//   });

//   return { seriesData, drilldownSeries };
// };

// const { seriesData, drilldownSeries } = processData(manualData);

// const options = {
//   chart: {
//     type: "column",
//   },
//   title: {
//     text: "List of Categories and Subcategories",
//     style: {
//       color: "#333333",
//       fontFamily: "'Montserrat', serif",
//       fontSize: "20px",
//       fontWeight: "bold",
//     },
//   },

//   xAxis: {
//     type: "category",
//     style: {
//       textDecoration: "none",
//       color: "#333333",
//     },
//   },
//   credits: {
//     enabled: false,
//   },
//   yAxis: {
//     title: {
//       text: "% of Medicare",
//       style: {
//         color: "#555555",
//         fontFamily: "'Roboto Flex', serif",
//         fontSize: "12px",
//       },
//     },
//   },
//   plotOptions: {
//     series: {
//       borderWidth: 0,
//       dataLabels: {
//         enabled: true,
//       },
//     },
//   },
//   series: seriesData,
//   drilldown: {
//     series: drilldownSeries,
//     activeAxisLabelStyle: {
//       color: "#555555",
//       cursor: "pointer",
//       fontWeight: "normal",
//       fontSize: "11px",
//       fontFamily: "'Roboto Flex', serif",
//       textDecoration: "none",
//     },
//     activeDataLabelStyle: {
//       color: "#555555",
//       cursor: "pointer",
//       fontWeight: "bold",
//       fontSize: "12px",
//       fontFamily: "'Roboto Flex', serif",
//       textDecoration: "none",
//     },
//     breadcrumbs: {
//       buttonSpacing: 5,
//       buttonTheme: {
//         style: {
//           color: "#555555",
//           fontFamily: "'Roboto Flex', serif",
//           fontSize: "12px",
//           textDecoration: "none",
//           position: {
//             align: "left",
//             verticalAlign: "top",
//           },
//         },
//       },
//     },
//   },
// };

// const DrilldownChart = () => {
//   return (
//     <div>
//       <HighchartsReact highcharts={Highcharts} options={options} />
//     </div>
//   );
// };

// export default DrilldownChart;

import React, { useState } from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import HighchartsDrilldown from "highcharts/modules/drilldown";

// Initialize drilldown module
if (typeof Highcharts === "object") {
  HighchartsDrilldown(Highcharts);
}

const manualData = {
  "Category III Codes": {
    "Prostate Ablation Procedure": {
      "Anthem Participating Network": 272.95,
      "BC ID Blue Value POS Network": 333.09,
      "BC ID Preferred Blue Network": 333.09,
      "BC ID Preferred Blue PPO Network": 294.65,
    },
    "Atherectomy (Open or Percutaneous) for Supra-Inguinal Arteries": {
      "Anthem Participating Network": 147.22,
      "BC ID Blue Value POS Network": 147.22,
      "BC ID Preferred Blue Network": 147.22,
      "BC ID Preferred Blue PPO Network": 147.22,
    },
    "Laser Ablation Procedures": {
      "Anthem Participating Network": 605.01,
      "BC ID Blue Value POS Network": 605.01,
      "BC ID Preferred Blue Network": 605.01,
      "BC ID Preferred Blue PPO Network": 605.01,
    },
    "Stereotactic Intracranial Lesion Ablation Procedure": {
      "Anthem Participating Network": 338.44,
      "BC ID Blue Value POS Network": 298.36,
      "BC ID Preferred Blue Network": 298.36,
      "BC ID Preferred Blue PPO Network": 338.44,
    },
    "Transnasal EGD and Capsule Endoscopy Procedures": {
      "Anthem Participating Network": 584.68,
      "BC ID Blue Value POS Network": 584.68,
      "BC ID Preferred Blue Network": 584.68,
      "BC ID Preferred Blue PPO Network": 584.68,
    },
    "Carotid Sinus Baroreflex Activation Device Procedures": {
      "Anthem Participating Network": 278.66,
      "BC ID Blue Value POS Network": "Unavailable",
      "BC ID Preferred Blue Network": "Unavailable",
      "BC ID Preferred Blue PPO Network": 278.66,
    },
    "Imaging, Testing, Implantation and Other Services": {
      "Anthem Participating Network": 619.55,
      "BC ID Blue Value POS Network": 619.55,
      "BC ID Preferred Blue Network": 619.55,
      "BC ID Preferred Blue PPO Network": 619.55,
    },
    "Insertion of Aqueous Drainage Device": {
      "Anthem Participating Network": 207.97,
      "BC ID Blue Value POS Network": "Unavailable",
      "BC ID Preferred Blue Network": "Unavailable",
      "BC ID Preferred Blue PPO Network": 207.97,
    },
    "Intracardiac Ischemia Monitoring Procedures": {
      "Anthem Participating Network": 153.86,
      "BC ID Blue Value POS Network": 153.86,
      "BC ID Preferred Blue Network": 153.86,
      "BC ID Preferred Blue PPO Network": 153.86,
    },
    "Percutaneous Lumbar Intravertebral Disc Injection Procedure": {
      "Anthem Participating Network": 178.15,
      "BC ID Blue Value POS Network": 178.15,
      "BC ID Preferred Blue Network": 178.15,
      "BC ID Preferred Blue PPO Network": 178.15,
    },
  },
  "Chemotherapy Drugs": {
    "Chemotherapy Drugs": {
      "Anthem Participating Network": 250.98,
      "BC ID Blue Value POS Network": 243.03,
      "BC ID Preferred Blue Network": 243.03,
      "BC ID Preferred Blue PPO Network": 242.29,
    },
  },
  "Drugs Administered Other than Oral Method": {
    "Drugs, Administered by Injection": {
      "Anthem Participating Network": 260.7,
      "BC ID Blue Value POS Network": 247.36,
      "BC ID Preferred Blue Network": 247.36,
      "BC ID Preferred Blue PPO Network": 252.38,
    },
    "Miscellaneous Drugs": {
      "Anthem Participating Network": 234.78,
      "BC ID Blue Value POS Network": 239.27,
      "BC ID Preferred Blue Network": 239.27,
      "BC ID Preferred Blue PPO Network": 235.47,
    },
    "Clotting Factors": {
      "Anthem Participating Network": 227.49,
      "BC ID Blue Value POS Network": 215.47,
      "BC ID Preferred Blue Network": 215.47,
      "BC ID Preferred Blue PPO Network": 214.66,
    },
    "Chemotherapy Drugs, Oral Administration": {
      "Anthem Participating Network": 241.13,
      "BC ID Blue Value POS Network": "Unavailable",
      "BC ID Preferred Blue Network": "Unavailable",
      "BC ID Preferred Blue PPO Network": 241.13,
    },
    "Immunosuppressive Drugs": {
      "Anthem Participating Network": 188.53,
      "BC ID Blue Value POS Network": 188.53,
      "BC ID Preferred Blue Network": 188.53,
      "BC ID Preferred Blue PPO Network": 188.53,
    },
  },
  "Evaluation and Management": {
    "Preventive Medicine Services": {
      "Anthem Participating Network": 298.53,
      "BC ID Blue Value POS Network": 288.5,
      "BC ID Preferred Blue Network": 288.5,
      "BC ID Preferred Blue PPO Network": 312.29,
    },
    "Transitional Care Management Services": {
      "Anthem Participating Network": 309.17,
      "BC ID Blue Value POS Network": 314.26,
      "BC ID Preferred Blue Network": 314.26,
      "BC ID Preferred Blue PPO Network": 322.86,
    },
    "Psychiatric Collaborative Care Management Services": {
      "Anthem Participating Network": 293.26,
      "BC ID Blue Value POS Network": 213.38,
      "BC ID Preferred Blue Network": 213.38,
      "BC ID Preferred Blue PPO Network": 293.26,
    },
    "Care Management Services": {
      "Anthem Participating Network": 204.65,
      "BC ID Blue Value POS Network": 204.65,
      "BC ID Preferred Blue Network": 204.65,
      "BC ID Preferred Blue PPO Network": 204.65,
    },
    "Newborn Care Services": {
      "Anthem Participating Network": 389.88,
      "BC ID Blue Value POS Network": 389.88,
      "BC ID Preferred Blue Network": 389.88,
      "BC ID Preferred Blue PPO Network": 389.88,
    },
    "Delivery/Birthing Room Attendance and Resuscitation Services": {
      "Anthem Participating Network": 209.07,
      "BC ID Blue Value POS Network": 209.07,
      "BC ID Preferred Blue Network": 209.07,
      "BC ID Preferred Blue PPO Network": 209.07,
    },
  },
  "Medicine Services and Procedures": {
    "Cardiovascular Procedures": {
      "Anthem Participating Network": 360.68,
      "BC ID Blue Value POS Network": 339.42,
      "BC ID Preferred Blue Network": 339.42,
      "BC ID Preferred Blue PPO Network": 359.71,
    },
  },
};

const processData = (data) => {
  const seriesData = [];
  const drilldownSeries = [];

  // Define the color palette
  const colorPalette = ["#c0e7e7", "#feb187", "#d1e8ff", "#ffd29f", "#507a8a"];

  Object.entries(data).forEach(([category, subcategories], categoryIndex) => {
    const categoryData = [];

    Object.entries(subcategories)
      .sort(([a], [b]) => a.localeCompare(b))
      .forEach(([subcategory, networks], subIndex) => {
        const subcategoryId = `${category}-${subcategory}`;
        categoryData.push({
          name: subcategory,
          y: Object.values(networks)[0],
          drilldown: subcategoryId,
        });

        const networkData = Object.entries(networks).map(([network, value]) => [
          network,
          value,
        ]);
        drilldownSeries.push({ id: subcategoryId, data: networkData });
      });

    // Assign the same color for all subcategories within the same category
    seriesData.push({
      name: category,
      data: categoryData,
      color: colorPalette[categoryIndex % colorPalette.length], // Cycle through the color palette
    });
  });

  return { seriesData, drilldownSeries };
};

const { seriesData, drilldownSeries } = processData(manualData);

const options = {
  chart: {
    type: "column",
  },
  title: {
    text: "List of Categories and Subcategories",
    style: {
      color: "#333333",
      fontFamily: "'Montserrat', serif",
      fontSize: "20px",
      fontWeight: "bold",
    },
  },

  xAxis: {
    type: "category",
    style: {
      textDecoration: "none",
      color: "#333333",
    },
    labels: {
      rotation: 0,
      style: {
        fontSize: "12px",
        whiteSpace: "nowrap",
        textOverflow: "ellipsis",
        fontSize: "12px",
        width: "100px",
      },
    },
  },
  credits: {
    enabled: false,
  },
  yAxis: {
    title: {
      text: "% of Medicare",
      style: {
        color: "#555555",
        fontFamily: "'Roboto Flex', serif",
        fontSize: "12px",
      },
    },
  },
  tooltip: {
    headerFormat:
      '<span style="font-size: 14px; color: #5A5A5A;  max-width: 120px; white-space: normal; word-wrap: break-word;">{point.key}</span><br>' +
      '<span style="color: #E96926; font-size: 14px;">&#9472;&#9472;&#9472;</span> <br>',
    pointFormat:
      "<div style='display:flex; flex-direction:row; align-items: center; justify-content: space-between;'  ><div style='margin-right: 0px; width:120px; white-space: normal; word-wrap: break-word;'> {series.name} </div> <div style=' display: flex;  justify-content: right; !important; width: 80px; '><b>{point.y}%</b></div> </div>",
    shared: true,
    backgroundColor: "rgba(255, 255, 255, 1)",
    borderColor: "#A9A9A9",
    borderRadius: 7,
    animation: false,
    hideDelay: 0,
    style: {
      color: "#333",
      fontFamily: "'Roboto Flex', serif",
      transition: "none",
      fontSize: "12px",
      padding: "8px",
      shadow: "1px 1px 1px rgba(220, 220, 220, 0.1)",
      zIndex: 99999,
    },
    shadow: true,
    useHTML: true,
    outside: true,
  },
  plotOptions: {
    series: {
      borderWidth: 0,
      dataLabels: {
        enabled: true,
        style: {
          color: "#555555",
          cursor: "pointer",
          border: "none",
          fontWeight: 500,
          fontSize: "12px",
          fontFamily: "'Roboto Flex', serif",
          textDecoration: "none",
        },
      },
    },
  },
  series: seriesData,
  drilldown: {
    series: drilldownSeries,
    drilldown: {
      series: drilldownSeries,
    },

    activeAxisLabelStyle: {
      color: "#555555",
      cursor: "pointer",
      fontWeight: "normal",
      fontSize: "11px",
      fontFamily: "'Roboto Flex', serif",
      textDecoration: "none",
    },
    activeDataLabelStyle: {
      color: "#555555",
      cursor: "pointer",
      border: "none",
      fontWeight: 500,
      fontSize: "12px",
      fontFamily: "'Roboto Flex', serif",
      textDecoration: "none",
    },
    breadcrumbs: {
      buttonSpacing: 5,
      buttonTheme: {
        style: {
          color: "#555555",
          fontFamily: "'Roboto Flex', serif",
          fontSize: "12px",
          textDecoration: "none",
          position: {
            align: "left",
            verticalAlign: "top",
          },
        },
      },
    },
  },
};

const DrilldownChart = () => {
  const [showTooltip, setShowTooltip] = useState(false);
  return (
    // <div>
    //   <HighchartsReact highcharts={Highcharts} options={options} />
    // </div>
    // <div
    //   style={{ position: "relative", backgroundColor: "#fff", padding: "10px" }}
    // >
    //   <HighchartsReact highcharts={Highcharts} options={options} />
    //   <div
    //     style={{
    //       position: "absolute",
    //       top: "20px",
    //       right: "60px", // Adjust based on menu icon position
    //       backgroundColor: "#f4f4f9",
    //       color: "#333",
    //       borderRadius: "4px",
    //       padding: "3px 10px",
    //       fontSize: "12px",
    //       fontFamily: "'Roboto Flex', sans-serif",
    //       fontWeight: "500",
    //       boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
    //     }}
    //   >
    //     Drilldown Chart
    //   </div>
    // </div>

    <div
      style={{
        position: "relative",
        backgroundColor: "#fff",
        padding: "10px",
      }}
    >
      <HighchartsReact highcharts={Highcharts} options={options} />
      <div
        style={{
          position: "absolute",
          top: "23px",
          right: "60px",
        }}
      >
        <div
          onMouseEnter={() => setShowTooltip(true)}
          onMouseLeave={() => setShowTooltip(false)}
          style={{
            backgroundColor: "#f4f4f9",
            color: "#333",
            borderRadius: "4px",
            padding: "3px 10px",
            fontSize: "12px",
            fontFamily: "'Roboto Flex', sans-serif",
            fontWeight: "500",
            boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
            cursor: "default",
          }}
        >
          Drilldown Chart
        </div>

        {showTooltip && (
          <div
            style={{
              position: "absolute",
              top: "30px",
              right: "0",
              backgroundColor: "#fff",
              color: "#333",
              borderRadius: "4px",
              border: ".9px  solid lightgrey",
              // border: ".5px  solid",
              padding: "5px 10px",
              fontSize: "12px",
              fontFamily: "'Roboto Flex', sans-serif",
              fontWeight: "500",
              boxShadow: "0 1px 3px rgba(50, 50, 50, 0.1)",
              whiteSpace: "nowrap",
              zIndex: 10,
            }}
          >
            Click chart elements to explore deeper levels of data.
          </div>
        )}
      </div>
    </div>
  );
};

export default DrilldownChart;
